import React from 'react';
import type FieldSettingsType from '@atlassian/jira-spa-apps-project-settings-fields/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyFieldsSettings = lazyForPaint<typeof FieldSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-fields", jiraSpaEntry: "async-project-settings-fields" */ '@atlassian/jira-spa-apps-project-settings-fields'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyFieldsSettings} pageId="project-settings-fields" shouldShowSpinner />
);
